export default __webpack_public_path__ + "images/Stcourier_favicon.svg";